var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "card-pos",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,13.942,13.942,0",
    transform: "translate(4.585 4.584)",
    fill: "none",
    stroke: "#1a1944",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,1.4,1.4,0",
    transform: "translate(12.951 19.925)",
    fill: "none",
    stroke: "#1a1944",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,2.788,2.788,0",
    transform: "translate(16.092 15.399)",
    fill: "none",
    stroke: "#1a1944",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M1.868,9.61,9.615,1.864c2.473-2.473,3.71-2.485,6.16-.035L21.5,7.557c2.45,2.45,2.438,3.687-.035,6.16l-7.747,7.747c-2.473,2.473-3.71,2.485-6.16.035L1.833,15.77C-.617,13.32-.617,12.1,1.868,9.61Z",
    transform: "translate(2.333 2.335)",
    fill: "none",
    stroke: "#1a1944",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H23.333",
    transform: "translate(2.333 25.665)",
    fill: "none",
    stroke: "#1a1944",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    fill: "none",
    opacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentBlack);
export default __webpack_public_path__ + "static/media/paymentBlack.d49279437af5eec8c84c7d5be15cc548.svg";
export { ForwardRef as ReactComponent };